/**
 * Full, locale-grouped counts for metric displays; compact counts for chart axes.
 * Missing metrics stay distinct from zero.
 */
const COUNT_FORMATTER = new Intl.NumberFormat(undefined, {
  maximumFractionDigits: 0,
});

const COMPACT_COUNT_FORMATTER = new Intl.NumberFormat(undefined, {
  notation: 'compact',
  maximumFractionDigits: 1,
});

export function formatCount(value: number | null | undefined): string {
  return value == null ? '--' : COUNT_FORMATTER.format(value);
}

export function formatCompactCount(value: number): string {
  return COMPACT_COUNT_FORMATTER.format(value);
}
